var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgTopRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 263,
    viewBox: "0 0 375 263",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3893_26546)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M113.047 -16.959L251.971 117.382C263.882 128.901 276.797 125.206 280.818 109.133L307.971 0.592934C318.877 -42.9883 292.691 -68.3143 249.488 -55.9606L113.047 -16.959Z",
    fill: "#F9C416"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M342.678 -30.9697L286.038 153.781C281.182 169.622 290.334 179.451 306.487 175.735L415.542 150.642C459.335 140.572 470.008 105.743 439.385 72.8678L342.682 -30.9697H342.678Z",
    fill: "#F9C416"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3893_26546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 375,
    height: 263
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M375 0H0V263H375V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3893_26546)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3893_26546"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 263,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgTopRight);
export default __webpack_public_path__ + "static/media/bgTopRight.c114c9a12b2b21377d5bc69802ffdeae.svg";
export { ForwardRef as ReactComponent };